import React from "react";
import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import HowItWorks from './components/HowItWorks';
import HowItWorksSelector from './components/HowItWorksSelector';
import OwnerSteps from './components/OwnerSteps';
import FinderSteps from './components/FinderSteps';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import FAQ from './components/FAQ';
import FAQcontent from './components/FAQcontent';
import LoginPage from './components/LoginPage'; 
import RegisterPage from './components/RegisterPage';
import WaitlistPage from './components/WaitlistPage';
import MobileAccessModal from './components/MobileAccessModal';
import { isMobile } from 'react-device-detect';
import { AnimatePresence } from 'framer-motion';
import TermsPage from "./components/TermsPage";
import PrivacyPage from "./components/PrivacyPage";
import AccesibilityPage from "./components/AccesibilityPage";




function ScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/' && location.hash) {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  return null;
}

function LandingPage({ language, setLanguage }) {
  const [selectedView, setSelectedView] = useState(null);
  const resetSelection = () => setSelectedView(null);

  return (
    <div className="min-h-screen font-sans text-gray-800 bg-white">
      <ScrollToHash />
      <Hero language={language} />
      <HowItWorks language={language} />
      {!selectedView && (
        <HowItWorksSelector language={language} onSelect={setSelectedView} />
      )}
      {selectedView === 'owner' && (
        <OwnerSteps language={language} onBack={resetSelection} />
      )}
      {selectedView === 'finder' && (
        <FinderSteps language={language} onBack={resetSelection} />
      )}
      <FAQ language={language} />
      <FAQcontent language={language} />
    </div>
  );
}

export default function LandingYLF() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang) {
      setLanguage(savedLang);
    } else {
      const browserLang = navigator.language.startsWith('es')
        ? 'es'
        : navigator.language.startsWith('pt')
        ? 'pt'
        : 'en';
      setLanguage(browserLang);
    }
  }, []);
  useEffect(() => {
  const remembered = localStorage.getItem('ylf_mobile_choice');
  if (isMobile && !remembered) {
    setShowModal(true);
  }
}, []);


  const handleLanguageChange = (newLang) => {
    setLanguage(newLang);
    localStorage.setItem('preferredLanguage', newLang);
  };
  const [showModal, setShowModal] = useState(false);


  return (
    <div className="min-h-screen flex flex-col font-sans text-gray-800 bg-white">
     
	{showModal && (
	  <MobileAccessModal
		language={language}
		onClose={() => setShowModal(false)}
	  />
	)}
	  <Header language={language} onLanguageChange={handleLanguageChange} />
      <div className="flex-grow">
        <Routes>
		  <Route path="/" element={<LandingPage language={language} setLanguage={setLanguage} />} />
		  <Route path="/about" element={<AboutPage language={language} />} />
		  <Route path="/contact" element={<ContactPage language={language} />} />
		  <Route path="/login" element={<LoginPage language={language} />} />
		  <Route path="/register" element={<RegisterPage language={language} />} />
		  <Route path="/waitlist" element={<WaitlistPage language={language} />} />
		  <Route path="/terms" element={<TermsPage language={language} />} />
		  <Route path="/privacy" element={<PrivacyPage language={language} />} />
		  <Route path="/Accessibility" element={<AccesibilityPage language={language} />} />
		  
		  
		  
		</Routes>
      </div>
      <Footer language={language} />
    </div>
  );
}
